<template>
  <div id="parties">
    <h5>{{ $t("contract.parties.headline") }}</h5>
    <table style="width: 100%">
      <tr>
        <td>
          <p>
            <span class="user-output">{{ companyName }}</span>
            <br />
            <span class="user-output">{{ companyAddress }}</span>
            <br />
            <span>{{ $t("contract.parties.label.cvr") }}</span
            ><span class="user-output">{{ companyCvr }}</span>
            <br />
            <br />
            <span class="callname">{{
              $t("contract.parties.label.company")
            }}</span>
          </p>
        </td>
      </tr>
    </table>

    <p class="bold">{{ $t("contract.parties.and") }}</p>
    <table style="width: 100%">
      <tr>
        <td>
          <p>
            <span class="user-output">{{ supplierName }}</span>
            <br />
            <span class="user-output">{{ supplierAddress }}</span>
            <br />
            <span>{{ $t("contract.parties.label.cvr") }}</span
            ><span class="user-output">{{ supplierCvr }}</span>
            <br />
            <br />
            <span class="callname">{{
              $t("contract.parties.label.supplier")
            }}</span>
          </p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  computed: {
    parties() {
      return this.$store.state.contract.parties;
    },
    companyName() {
      return this.parties.company.name !== ""
        ? this.parties.company.name
        : this.$t("contract.parties.placeholder.name");
    },
    companyAddress() {
      return this.parties.company.address !== ""
        ? this.parties.company.address
        : this.$t("contract.parties.placeholder.address");
    },
    companyCvr() {
      return this.parties.company.cvr !== ""
        ? this.parties.company.cvr
        : this.$t("contract.parties.placeholder.cvr");
    },
    supplierName() {
      return this.parties.supplier.name !== ""
        ? this.parties.supplier.name
        : this.$t("contract.parties.placeholder.name");
    },
    supplierAddress() {
      return this.parties.supplier.address !== ""
        ? this.parties.supplier.address
        : this.$t("contract.parties.placeholder.address");
    },
    supplierCvr() {
      return this.parties.supplier.cvr !== ""
        ? this.parties.supplier.cvr
        : this.$t("contract.parties.placeholder.cvr");
    },
  },
};
</script>

<style scoped>
.callname {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/contract/PartiesOutput.vue